import { render, staticRenderFns } from "./editPermissionDialog.vue?vue&type=template&id=1bb254fa&scoped=true&"
import script from "./editPermissionDialog.vue?vue&type=script&lang=js&"
export * from "./editPermissionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb254fa",
  null
  
)

export default component.exports